import React from "react";
import PropTypes from "prop-types";
import Services from "./Services";
import TemplateManager from "./templates/TemplateManager";
import useApp from "./hooks/use-app";
import {DocumentTitle} from "./helpers";

function Page(props) {

    const app = useApp();
    const template = props.defaultTemplate || app.defaultTemplate();

    return (
        <Services>
            <TemplateManager defaultTemplate={template}>
                <DocumentTitle />
                {props.children}
            </TemplateManager>
        </Services>
    );
}

Page.defaultProps = {
    defaultTemplate: null,
};

Page.propTypes = {
    defaultTemplate: PropTypes.string,
};

export default Page;
